/* eslint-disable max-len */
import { APP_CONFIG } from '@constants';

const upload = require('superagent');

export const UPDATE_TITLE_FIELD = 'treasureChestConfig/UPDATE_TITLE_FIELD';
export const UPDATE_SUBTITLE_FIELD = 'treasureChestConfig/UPDATE_SUBTITLE_FIELD';
export const UPDATE_CHESTCONFIG_FIELD = 'treasureChestConfig/UPDATE_CHESTCONFIG_FIELD';
export const UPDATE_TEMPLATECONFIG_FIELD = 'treasureChestConfig/UPDATE_TEMPLATECONFIG_FIELD';
export const UPDATE_RESULT_FIELD = 'treasureChestConfig/UPDATE_RESULT_FIELD';
export const UPDATE_APPCONFIG_FIELD = 'treasureChestConfig/UPDATE_APPCONFIG_FIELD';
export const UPDATE_BUTTON = 'treasureChestConfig/UPDATE_BUTTON';

export const UPLOAD_IMAGE_REQUESTED = 'upload/UPLOAD_IMAGE_REQUESTED';
export const UPLOAD_IMAGE_SUCCESS = 'upload/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILURE = 'upload/UPLOAD_IMAGE_FAILURE';

export const SAVE_CONFIG_REQUESTED = 'save/SAVE_CONFIG_REQUESTED';
export const SAVE_CONFIG_SUCCESS = 'save/SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILURE = 'save/SAVE_CONFIG_FAILURE';

export const UPDATE_CONFIG_REQUESTED = 'update/UPDATE_CONFIG_REQUESTED';
export const UPDATE_CONFIG_SUCCESS = 'update/UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_FAILURE = 'update/UPDATE_CONFIG_FAILURE';

export const GET_CONFIG_REQUESTED = 'get/GET_CONFIG_REQUESTED';
export const GET_CONFIG_SUCCESS = 'get/GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'get/GET_CONFIG_FAILURE';

export const DUPLICATE_CONFIG_REQUESTED = 'get/DUPLICATE_CONFIG_REQUESTED';
export const DUPLICATE_CONFIG_SUCCESS = 'get/DUPLICATE_CONFIG_SUCCESS';
export const DUPLICATE_CONFIG_FAILURE = 'get/DUPLICATE_CONFIG_FAILURE';

export const UPDATE_FIELD = 'treasureChestConfig/UPDATE_FIELD';
export const UPDATE_PAGE = 'treasureChestConfig/UPDATE_PAGE';

export const UPDATE_ACTIVE_FLAG = 'treasureChestConfig/UPDATE_ACTIVE_FLAG';
export const UPDATE_LOCALIZATION_FLAG = 'treasureChestConfig/UPDATE_LOCALIZATION_FLAG';
export const UPDATE_CONFIG_FIELD = 'treasureChestConfig/UPDATE_CONFIG_FIELD';
export const REMOVE_CONFIG = 'treasureChestConfig/REMOVE_CONFIG';
export const CLEAR_STATE = 'treasureChestConfig/CLEAR_STATE';
export const UPDATE_BUTTON_CONFIG = 'treasureChestConfig/UPDATE_BUTTON_CONFIG';
export const UPDATE_QUESTIONS_FIELD = 'treasureChestConfig/UPDATE_QUESTIONS_FIELD';
export const UPDATE_COLLAPSE = 'treasureChestConfig/UPDATE_COLLAPSE';
export const UPDATE_ADDSETTINGS_CONFIG = 'treasureChestConfig/UPDATE_ADDSETTINGS_CONFIG';
export const UPDATE_DISPLAYWIZARD = 'treasureChestConfig/UPDATE_DISPLAYWIZARD';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  initialValues: {
    fontTitlePositions: [],
    treasureCount: [],
    fonts: [],
    fontStrength: [],
    fontSize: [],
    spinButtonWidth: [],
    spinButtonRadius: [],
    spinButtonShadow: [],
    fontPositions: [],
    buttonAction: [],
    outlineStyles: [],
    themeList: [],
  },
  localizationFlag: '',
  activeNavTab: 'English',
  config: {
    localizationconfig: [
      {
        language: 'English',
        resultHandler: 'ParentApp',
        title: {
          text: 'Search & Win',
          color: '#FFFFFF',
          font: {
            size: '24',
            strength: '600',
            family: 'Poppins',
            align: 'center',
          },
          position: 'center',
          titleError: '',
          disableSave: false,
          templateName: {
            text: '',
          },
          templateError: '',
        },
        subtitle: {
          text: 'Answer & Win Exciting Prize',
          color: '#FFFFFF',
          font: {
            size: '16',
            strength: '400',
            family: 'Poppins',
            align: 'center',
          },
          titleError: '',
        },
        chestConfig: {
          shortDescription: '',
          count: '4',
          chestOpenImage:
          'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/treasureChest%2F5824_win.png?alt=media',
          chestOpenImageName: '',
          chestOpenImageError: '',
          chestCloseImage:
          'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/treasureChest%2F5000_closed.png?alt=media',
          chestCloseImageName: '',
          chestCloseImageError: '',
          bgColor: '#ffffffff',
          showProgressBar: true,
          bgImage: 'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/treasureChest%2F13%2F15%2F1477_tcbg.png?alt=media',
          theme: 'forest',
          themeBackground: '',
          themeForeground: '',
          bgImageName: 'backgroundImage.png',
          backgroundError: '',
          chestBoard:
          'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/treasureChest%2F4528_benchTC.png?alt=media',
          chestEmptyImage:
          'https://www.googleapis.com/download/storage/v1/b/ec2-us-east-1-1b-dev-images-gamification/o/treasureChest%2F5753_empty.png?alt=media',
          chestEmptyImageName: '',
          chestEmptyImageError: '',
        },
        predefinedTemplate: {
          page: 1,
          perPage: 3,
          list: [
            {
              name: 'Forest',
              image: '',
              value: 'forest',
            },
          ],
        },
        resultText: {
          winningText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: '',
          },
          losingText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: '',
          },
        },
        buttonNeeded: true,
        buttonConfig: [
          {
            text: {
              text: '',
              color: '#000000',
              font: {
                size: '14',
                strength: '400',
                family: 'Arial, sans-serif',
                align: 'left',
              },
            },
            textColor: '#000000',
            image: {
              url: '',
              name: ''
            },
            imageError: '',
            width: 'auto',
            radius: '30px',
            shadow: '0px 0px',
            shadowColor: '#cdcdcd',
            position: 'left',
            bgColor: '#ffffff',
            border: '#000000',
            hoverBgColor: '#cdcdcd',
            buttonTextError: '',
            borderWidth: '1px',
            appLink: {
              text: ''
            },
            webLink: {
              text: ''
            },
            appLinkError: '',
            webLinkError: ''
          }
        ],
        displayWizard: {
          themeId: '',
          themeIdError: '',
          displayType: 'popup',
          winningText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: ''
          },
          losingText: {
            img: '',
            imageName: '',
            text: '',
            color: '#000000',
            font: {
              size: '14',
              strength: '400',
              family: 'Arial, sans-serif',
              align: 'left',
            },
            error: '',
            errorImg: ''
          },
        },
        additionalSettings: {
          titleFontStyle: 'Outfit, sans-serif',
          titleFontWt: '400',
          titleFontSize: '12',
          titleFontColor: '#ffffff',
          subtitleFontStyle: 'Outfit, sans-serif',
          subtitleFontWt: '400',
          subtitleFontSize: '12',
          subtitleFontColor: '#ffffff',
          buttonFontStyle: 'Outfit, sans-serif',
          buttonFontWt: '400',
          buttonFontSize: '12',
          buttonFontColor: '#ffffff',
          backgroundColor1: '#000000',
          backgroundColor2: '#000000',

          winningText: '',
          winningTextError: '',
          winningImg: '',
          winningImgName: '',
          winningImgError: '',
          losingText: '',
          losingTextError: '',
          losingImg: '',
          losingImgName: '',
          losingImgError: '',

          winningWebURL: '',
          winningAppURL: '',
          losingWebURL: '',
          losingAppURL: '',
          rewardIcon: '',
          rewardIconName: '',
          selectedRewardIconIndex: 1,
          offerDetailsTitle: {
            text: ''
          },
          instructionsTitle: {
            text: ''
          },
          winningMsgFontStyle: 'Outfit, sans-serif',
          winningMsgFontWt: '400',
          winningMsgFontSize: '12',
          winningMsgFontColor: '#ffffff',
          losingMsgFontStyle: 'Outfit, sans-serif',
          losingMsgFontWt: '400',
          losingMsgFontSize: '12',
          losingMsgFontColor: '#ffffff',
          offerDetailsFontStyle: 'Outfit, sans-serif',
          offerDetailsFontWt: '400',
          offerDetailsFontSize: '12',
          offerDetailsFontColor: '#ffffff',
          instructionsFontStyle: 'Outfit, sans-serif',
          instructionsFontWt: '400',
          instructionsFontSize: '12',
          instructionsFontColor: '#ffffff',
        },
        libraries: {
          iconLibrary: [],
        },
        themeConfig: {},
      },
    ]
  },
  collapse: {
    displayWizard: false,
    activity: false,
    additionalSettings: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_IMAGE_REQUESTED: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    case UPLOAD_IMAGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case UPLOAD_IMAGE_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case SAVE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SAVE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case SAVE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_BUTTON_CONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_QUESTIONS_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_BUTTON: {
      console.log('ssssss', action.payload);
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i] = state.config.localizationconfig[i]
            ? {
              ...state.config.localizationconfig[i],
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case UPDATE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case DUPLICATE_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    case DUPLICATE_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case DUPLICATE_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case GET_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case GET_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case UPDATE_CONFIG_FIELD: {
      console.log('action', action.payload);
      const localizationconfig = [...state.config.localizationconfig, ...action.payload.localizationconfig];
      const config = {
        ...state.config,
        localizationconfig
      };
      return { ...state, config };
    }
    case UPDATE_LOCALIZATION_FLAG: {
      return { ...state, localizationFlag: action.payload };
    }
    case UPDATE_ACTIVE_FLAG: {
      return { ...state, activeNavTab: action.payload };
    }
    case REMOVE_CONFIG: {
      return { ...state, config: action.payload };
    }
    case UPDATE_FIELD: {
      state = state
        ? {
          ...state,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_TITLE_FIELD: {
      console.log('title', action.payload);
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].title = state.config.localizationconfig[i].title
            ? {
              ...state.config.localizationconfig[i].title,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_SUBTITLE_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].subtitle = state.config.localizationconfig[i].subtitle
            ? {
              ...state.config.localizationconfig[i].subtitle,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_CHESTCONFIG_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].chestConfig = state.config.localizationconfig[i].chestConfig
            ? {
              ...state.config.localizationconfig[i].chestConfig,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_TEMPLATECONFIG_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].predefinedTemplate = state.config.localizationconfig[i].predefinedTemplate
            ? {
              ...state.config.localizationconfig[i].predefinedTemplate,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_RESULT_FIELD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].resultText = state.config.localizationconfig[i].resultText
            ? {
              ...state.config.localizationconfig[i].resultText,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_APPCONFIG_FIELD: {
      state.initialValues = state.initialValues
        ? {
          ...state.initialValues,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case CLEAR_STATE: {
      return { ...initialState };
    }
    case UPDATE_COLLAPSE: {
      state.collapse = state.collapse
        ? {
          ...state.collapse,
          ...action.payload,
        }
        : { ...action.payload };
      return { ...state };
    }
    case UPDATE_ADDSETTINGS_CONFIG: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].additionalSettings = state.config.localizationconfig[i].additionalSettings
            ? {
              ...state.config.localizationconfig[i].additionalSettings,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    case UPDATE_DISPLAYWIZARD: {
      for (let i = 0; i < state.config.localizationconfig.length; i += 1) {
        if (state.config.localizationconfig[i].language === action.payload.language) {
          state.config.localizationconfig[i].displayWizard = state.config.localizationconfig[i].displayWizard
            ? {
              ...state.config.localizationconfig[i].displayWizard,
              ...action.payload,
            }
            : { ...action.payload };
        }
      }
      return { ...state };
    }
    default:
      return state;
  }
};

export const updateTitle = (payload) => {
  return {
    type: UPDATE_TITLE_FIELD,
    payload,
  };
};

export const updateSubTitle = (payload) => {
  return {
    type: UPDATE_SUBTITLE_FIELD,
    payload,
  };
};
export const updateChest = (payload) => {
  return {
    type: UPDATE_CHESTCONFIG_FIELD,
    payload,
  };
};
export const templateUpdate = (payload) => {
  return {
    type: UPDATE_TEMPLATECONFIG_FIELD,
    payload,
  };
};

export const uploadimage = (file, folderName) => {
  const accessToken = window.localStorage.getItem('access_token');
  return {
    types: [UPLOAD_IMAGE_REQUESTED, UPLOAD_IMAGE_SUCCESS, UPLOAD_IMAGE_FAILURE],
    promise: () => upload
      .post(`${APP_CONFIG.CURRENT_GAMIFICATION_HOST_NAME}/gamification/upload`)
      .withCredentials()
      .set({ has_auth_token: 1 })
      .set('Authorization', `Bearer ${accessToken}`)
      .attach('files', file)
      .field('folderName', folderName),
  };
};
// action
export const updateFields = (payload) => {
  return {
    type: UPDATE_FIELD,
    payload,
  };
};

export const updatePage = (payload) => {
  return {
    type: UPDATE_PAGE,
    payload,
  };
};

export const saveTreasureChestConfig = (data) => {
  return {
    types: [SAVE_CONFIG_REQUESTED, SAVE_CONFIG_SUCCESS, SAVE_CONFIG_FAILURE],
    promise: client => client.post('saveScratchCardConfig', {
      data,
    }),
  };
};

export const getTreasureChestConfig = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getSpinWheel?gamificationId=${data}`),
  };
};

export const editTreasureChestConfig = (data, gamificationId) => {
  return {
    types: [UPDATE_CONFIG_REQUESTED, UPDATE_CONFIG_SUCCESS, UPDATE_CONFIG_FAILURE],
    promise: client => client.post(`saveScratchCardConfig?gamificationId=${gamificationId}`, {
      data,
    }),
  };
};
export const getTemplate = (data) => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get(`getTemplate?templateId=${data}`),
  };
};

export const duplicateTreasureChestTitle = (data, type, id) => {
  return {
    types: [DUPLICATE_CONFIG_REQUESTED, DUPLICATE_CONFIG_SUCCESS, DUPLICATE_CONFIG_FAILURE],
    promise: client => client.get(`duplicateSpinWheelTitle?title=${data}&type=${type}&id=${id}`),
  };
};

export const updateResult = (payload) => {
  return {
    type: UPDATE_RESULT_FIELD,
    payload,
  };
};

export const getAppConfig = () => {
  return {
    types: [GET_CONFIG_REQUESTED, GET_CONFIG_SUCCESS, GET_CONFIG_FAILURE],
    promise: client => client.get('getAppConfig'),
  };
};

export const updateDropdown = (payload) => {
  return {
    type: UPDATE_APPCONFIG_FIELD,
    payload,
  };
};
export const updateActiveFlag = (payload) => {
  return {
    type: UPDATE_ACTIVE_FLAG,
    payload,
  };
};
export const updateLocalizationFlag = (payload) => {
  return {
    type: UPDATE_LOCALIZATION_FLAG,
    payload,
  };
};
export const updateConfig = (payload) => {
  return {
    type: UPDATE_CONFIG_FIELD,
    payload
  };
};
export const removeConfig = (payload) => {
  return {
    type: REMOVE_CONFIG,
    payload
  };
};

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const updateButton = (payload) => {
  return {
    type: UPDATE_BUTTON,
    payload
  };
};

export const updateButtonConfig = (payload) => {
  return {
    type: UPDATE_BUTTON_CONFIG,
    payload
  };
};


export const updateQuestions = (payload) => {
  return {
    type: UPDATE_QUESTIONS_FIELD,
    payload,
  };
};

export const updateCollapse = (payload) => {
  return {
    type: UPDATE_COLLAPSE,
    payload
  };
};

export const updateAdditionalSettings = (payload) => {
  return {
    type: UPDATE_ADDSETTINGS_CONFIG,
    payload,
  };
};

export const updateDisplayWizard = (payload) => {
  return {
    type: UPDATE_DISPLAYWIZARD,
    payload,
  };
};
